import { CardProps } from '@/components/card/types';
import { HitAllResult } from '@/components/search/types';

export function mapGenericHit({
  title,
  category,
  content,
  permalink,
  thumbnail,
  date_published,
}: HitAllResult): CardProps {
  return {
    title,
    category: category || '',
    description: content?.slice(0, 200) || '',
    callToActionUrl: {
      url: (permalink as string) || '',
      slug: '',
      external: false,
    },
    titleUppercase: !thumbnail ? true : false,
    titleCustomFont: true,
    displayDescription: !thumbnail ? true : false,
    image: thumbnail || '',
    imageAlt: title || '',
    isoDate: date_published || '',
  };
}
